import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-advertisement-management-header',
  templateUrl: './advertisement-management-header.component.html',
  styleUrls: ['./advertisement-management-header.component.scss'],
  standalone: false,
})
export class AdvertisementManagementHeaderComponent {
  private readonly router = inject(Router);

  @Input() text: string;

  navigateToMyAdvertisements = () => this.router.navigate(['my-advertisements']);
  navigateToOfferForm = () => this.router.navigate(['offer']);
  navigateToRequestForm = () => this.router.navigate(['request']);
}
